import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

const InfoView: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  // Extract text content into an object for easier management
  const threatContent = {
    title: t('CAM_LEAK_TITLE'),
    description: t('CAM_LEAK_DESC'),
    cards: [
      {
        title: t('CAM_LEAK_CARD_RECORDING_TITLE'),
        description: t('CAM_LEAK_CARD_RECORDING_DESC'),
      },
      {
        title: t('CAM_LEAK_CARD_REPOSTING_TITLE'),
        description: t('CAM_LEAK_CARD_REPOSTING_DESC'),
      },
      {
        title: t('CAM_LEAK_CARD_PRIVATE_TITLE'),
        description: t('CAM_LEAK_CARD_PRIVATE_DESC'),
      },
      {
        title: t('CAM_LEAK_CARD_SHARING_TITLE'),
        description: t('CAM_LEAK_CARD_SHARING_DESC'),
      },
      {
        title: t('CAM_LEAK_CARD_IMPERSONATION_TITLE'),
        description: t('CAM_LEAK_CARD_IMPERSONATION_DESC'),
      },
      {
        title: t('CAM_LEAK_CARD_IDENTITY_TITLE'),
        description: t('CAM_LEAK_CARD_IDENTITY_DESC'),
      },
    ],
  };

  return (
    <section ref={sectionRef} className={`${styles.missionSection} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.container}>
        <h2 className={styles.title}>{threatContent.title}</h2>
        <p className={styles.description}>{threatContent.description}</p>
        <div className={styles.threatsGrid}>
          {threatContent.cards.map((threat, index) => (
            <div key={index} className={styles.threatCard}>
              <h3 className={styles.threatTitle}>{threat?.title || ''}</h3>
              <p className={styles.threatDescription}>{threat?.description || ''}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoView;
